export default __webpack_public_path__ + "static/media/trusted-4.1e098065.webp";